export class HotkeyManager {
    constructor() {
        this.registeredHotkeys = [];
        this.pressedKeys = new Map();
        window.addEventListener('keydown', e => {
            this.pressedKeys.set(e.key, e.repeat);
            this.registeredHotkeys.forEach(hotkey => {
                if ((hotkey.exact == null || !hotkey.exact) || hotkey.keys.length === this.pressedKeys.size) {
                    if (hotkey.keys.reduce((result, key) => {
                        var _a;
                        return result &&
                            this.pressedKeys.has(key) &&
                            (hotkey.repeat === true || !((_a = this.pressedKeys.get(key)) !== null && _a !== void 0 ? _a : true));
                    }, true)) {
                        if (hotkey.preventDefault === true)
                            e.preventDefault();
                        hotkey.handler([...this.pressedKeys.keys()]);
                    }
                }
            });
        });
        window.addEventListener('keyup', e => {
            if (this.pressedKeys.has(e.key)) {
                this.pressedKeys.delete(e.key);
            }
        });
    }
    registerHotkey(hotkey) {
        this.registeredHotkeys.push(hotkey);
    }
    removeHotkey(hotkey) {
        const index = this.registeredHotkeys.indexOf(hotkey);
        if (index !== -1) {
            this.registeredHotkeys.splice(index, 1);
            return true;
        }
        return false;
    }
}
